import React from "react";
import Button from '../../components/Button';

export default function ManiobrasPosturales() {

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Maniobras posturales</h4>
      </div>

      {/* Introducción */}
      <div className="text-justify">
        <p className="mb-4">Las maniobras posturales disminuyen las penetraciones y aspiraciones y ayudan a redirigir el bolo alimenticio con el menor esfuerzo para el paciente.</p>

        <p>A continuación, se presentan diferentes enlaces que llevan a maniobras posturales que puede realizar:</p>
      </div>

      {/* Enlaces */}

      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <a
          href="https://disfapp.es/maniobras-posturales-flexion-anterior"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Maniobra de flexión anterior</Button>
        </a>

        <a
          href="https://disfapp.es/maniobras-posturales-flexo-rotacion"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Maniobra flexo-rotación</Button>
        </a>
      </div>
    </div>
  );
}